export default __webpack_public_path__ + "static/media/slide_9.784ebf4b.jpg";